var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigure1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 258,
    viewBox: "0 0 102 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6031 0H-116.462L-189 128.963L-116.462 257.915H28.6031L101.13 128.963L28.6031 0ZM0.546661 208.048H-88.4164L-132.898 128.963L-88.4164 49.8783H0.546661L45.0282 128.963L0.546661 208.048Z",
    fill: "#0C67B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure1);
export default __webpack_public_path__ + "static/media/figure1.7b31dfa664dce7547b25fec69e564d9f.svg";
export { ForwardRef as ReactComponent };